import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const LinkSection = ({
  linkTitle,
  linkUrl,
  linkParams,
  getLinkParamLabel,
}: {
  linkTitle: string | null;
  linkUrl: string | null;
  linkParams: string[];
  getLinkParamLabel: (param: string) => string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.link")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit/link"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.link.title"),
          children: (
            <Typography color="text.secondary">
              {linkTitle ?? ""}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.link.url"),
          children: (
            <Typography color="text.secondary">
              {linkUrl ?? ""}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.link.param"),
          children: (
            <Stack direction="column" spacing={0.5}>
              {linkParams.map((param) => (
                <Typography key={param} color="text.secondary">
                  ・{getLinkParamLabel(param)}
                </Typography>
              ))}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default LinkSection;
